import { Component, OnInit } from '@angular/core';
import { SprekerService } from '../spreker.service';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {

  ticketType = '';
  currentStep = 'type';
  ticketAmount: number;
  price = 0;
  ticketEmail: string;
  ticketCoach: string;
  sprekers;

  constructor(private sprekerService: SprekerService) {
    this.sprekers = sprekerService.getSprekers();
  }

  ngOnInit(): void {
  }

  nextStep(step: string) {
    this.currentStep = step;
    if (step === 'amount') {
      switch (this.ticketType) {
        case 'early-bird':
          this.price = 45;
          break;
        case 'standard':
          this.price = 90;
          break;
        case 'all-in':
          this.price = 250;
          break;
        default:
          this.price = 0;
          break;
      }
    }
  }

  calculatePrice(){
    let totalPrice = this.ticketAmount * this.price;
    if (this.ticketAmount >= 6) { // when you order more than 6 tickets, you get a discount of 10%
      let discount = totalPrice * (10 / 100);
      totalPrice -= discount;
    }

    return totalPrice;
  }

  validEmail(){
    if(this.ticketEmail.indexOf('@') > 0 && this.ticketEmail.indexOf('@') < this.ticketEmail.length - 1){ 
      // if there is an @ symbol somewhere in the middle
      if(this.ticketEmail.indexOf('.') > this.ticketEmail.indexOf('@') && this.ticketEmail.indexOf('.') < this.ticketEmail.length - 1){
         // if there is a . somewhere after the @ but before the end
        return true;
      } else {
        return false;
      } 
    } else {
      return false;
    }
  }

}
